import axios from 'axios';
import serverConfig from './baseurl.js';
import qs from 'qs';
import { Toast } from 'vant';
import 'vant/lib/toast/style';

const serviceAxios = axios.create({
  baseURL: serverConfig.baseURL, //基础请求地址
  timeout: 20000, //请求超时设置
  withCredentials: false, // 跨域请求是否需要携带 cookie
});

serviceAxios.interceptors.request.use(
  (config) => {
    
    // 是否使用 Token,
    if(serverConfig.useTokenAuthorization) {
      config.headers["token"] = localStorage.getItem('token') || '';
      // config.headers["token"] = 'd8fed69a-3285-4c97-9310-744a3417a04e';
    }
    // 设置请求头
    if(config.method === "post") {
      if(config.custom){
        config.headers["content-type"] = "application/json"
      }else{
        // config.headers["content-type"] = "application/x-ww-form-urlencoded";
        // config.data = qs.stringify(config.data); //序列化  效果等同于下行代码
        // config.requestType = "form"
        
        config.headers["content-type"] = "multipart/form-data";
       
      }
      
    } else {
      config.headers["content-type"] = "application/json"
    }

    return config
  },
  (error) => {
    Promise.reject(error)
  }
);

serviceAxios.interceptors.request.use(
  function(config) {
    removereqQueue(config); // 检查是否重复发送请求
    addreqQueue(config); //将本次请求加入请求队列
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
);

serviceAxios.interceptors.response.use(
  (res) => {
    removereqQueue(res.config); //请求从请求队列移除
    return res
  },
  (error) => {
    removereqQueue(error.config || {}); //请求从请求队列移除
    //....
  }
);

serviceAxios.interceptors.response.use(
  (res) => {
    // console.log("响应打印", res);
    if(res.status === 200){
      // console.log("1111122222", res);
      let message = "";
      if(res && res.data) {
        switch (res.data.code) {
          case 302:
            message = "接口重定向了! ";
         
            break;
          case 400:
            message = "参数不正确! ";
            break;
          case 401:
            setTimeout(()=>{
              // window.location.href = urlHandle(res.data.url);
            }, 200)
          
            break;
          case 403:
            message = "您还没有权限操作! ";
            break;
          case 404:
            message = `请求地址出错: ${error.response.config.url}`;
            break;
          case 408:
            message = "请求超时! ";
            break;
          case 409:
            message = "系统已存在相同数据! "
            break;
          case 500:
            message = "服务器内部错误! "
            break;
          case 501:
            message = "服务未实现! "
            break;
          case 502:
            message = "回答错误! "
            break;
          case 503:
            message = "服务不可用"
            break;
          case 504:
            message = "服务暂时无法访问, 请稍后再试"
            break;
          case 505:
            message = "HTTP 版本不受支持! "
            break;
          default:
            let data = res.data;
            // console.log(666777,data)
            // 处理自己的业务逻辑,如 token 是否过期...
            return data;
            break;
        }
      }

    }else {
      return Promise.reject(res.statusText);
    }
  },
  (error) => {
    console.log(678678,error)

  }
);

function urlHandle(url) {
  let new_url;
  let appid = GetParam(url,'appid')
  let response_type = GetParam(url,'response_type')
  let scope = GetParam(url,'scope')
  let state = GetParam(url,'state')
  let connect_redirect = GetParam(url,'connect_redirect')
  const currentPage = encodeURIComponent(window.location.href)
  const openUrl = url.split("?")[0];
  new_url =  openUrl + '?appid=' + appid + '&redirect_uri=' + currentPage + '&response_type=' + response_type + '&scope=' + scope + '&state=' + state + '&connect_redirect=' + connect_redirect + '#wechat_redirect'
  console.log(55555,new_url)
  return new_url

// 截取code
}
function GetParam(url, code) {
  url = url + "";
  let regstr = "/(\\?|\\&)" + code + "=([^\\&]+)/";
  let reg = eval(regstr);
  //eval可以将 regstr字符串转换为 正则表达式
  let result = url.match(reg);
  if (result && result[2]) {
    return result[2];
  }
}

const reqQueue = new Map();
function addreqQueue(config){
  //调用生成唯一标识值函数, 生成 requestKey
  const requestKey = regsoleKey(config);
  //为每个请求创建一个专属的 CancelToken(用于取消请求)
  config.cancelToken = config.cancelToken || new axios.CancelToken((cancel)=>{
    // 判断 reqQueue 中是否含有 requestKey,
    // 将 requestKey 与 CancelToken 以键值对的形式保存到map对象中
    if(!reqQueue.has(requestKey)){
      reqQueue.set(requestKey,cancel)
    }
  });
}

function removereqQueue(config){
  // 标识值
  const requestKey = generateReqKey(config);

  if(reqQueue.has(requestKey)){
    // 取消之前发出请求
    const cancelToken = reqQueue.get(requestKey);
    cancelToken(requestKey);
    // 从队列移除
    reqQueue.delete(requestKey);
  }
}

function regsoleKey(config){
  const {method, url, params, data } = config;
  return [method, url, qs.stringify(params), qs.stringify(data)].join('&')
}

function generateReqKey(config){
  const {method, url, params, data} = config;
  return [method, url, qs.stringify(params), qs.stringify(data)].join('&')
}

// 最后
export default serviceAxios




// WEBPACK FOOTER //
// ./src/api/index.js